"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductCollectionSortItem, ProductSortItem } from "@repo/graphql-shopify-storefront";
import { usePathname, useSearchParams } from "next/navigation";
import { RefineByListItem } from "#/components/molecules/search-refinements/refine-by-list-item";
export function RefineBySortByQueryParameterItem(t0) {
  const $ = _c(19);
  const {
    item
  } = t0;
  const pathname = usePathname();
  const currentSearchParams = useSearchParams();
  const active = currentSearchParams?.get("sort") === item.slug;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let title;
  if ($[0] !== active || $[1] !== currentSearchParams || $[2] !== item.slug || $[3] !== item.title || $[4] !== pathname) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const searchParams = new URLSearchParams(currentSearchParams);
      if (item.slug) {
        searchParams.set("sort", item.slug);
      }
      title = item.title;
      if (!pathname) {
        t4 = null;
        break bb0;
      }
      T0 = RefineByListItem;
      t3 = active;
      t1 = pathname;
      t2 = searchParams.toString();
    }
    $[0] = active;
    $[1] = currentSearchParams;
    $[2] = item.slug;
    $[3] = item.title;
    $[4] = pathname;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = title;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    title = $[10];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2) {
    t5 = {
      pathname: t1,
      search: t2
    };
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== T0 || $[15] !== t3 || $[16] !== t5 || $[17] !== title) {
    t6 = <T0 active={t3} href={t5} title={title} />;
    $[14] = T0;
    $[15] = t3;
    $[16] = t5;
    $[17] = title;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}